var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBowling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 23C35.9573 23 23 35.9573 23 52C23 68.0427 35.9573 81 52 81C68.0427 81 81 68.0427 81 52C81 35.9573 68.0427 23 52 23ZM39.7831 54.5915C37.1917 54.5915 35.2171 52.4938 35.2171 50.0254C35.2171 47.434 37.3148 45.4594 39.7831 45.4594C42.3746 45.4594 44.3492 47.5571 44.3492 50.0254C44.3492 52.4938 42.251 54.5915 39.7831 54.5915ZM47.1873 38.1785C47.1873 35.5871 49.285 33.6125 51.7533 33.6125C54.3448 33.6125 56.3194 35.7102 56.3194 38.1785C56.3194 40.6465 54.2217 42.7446 51.7533 42.7446C49.285 42.8681 47.1873 40.77 47.1873 38.1785ZM56.319 57.9233C53.7275 57.9233 51.7529 55.8256 51.7529 53.3573C51.7529 50.7658 53.8506 48.7912 56.319 48.7912C58.9104 48.7912 60.885 50.889 60.885 53.3573C61.0085 55.8256 58.9104 57.9233 56.319 57.9233Z",
    fill: "#592EE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowling);
export default __webpack_public_path__ + "static/media/Bowling.2d9ef2da547bf7b7de1f35dd4f9c6296.svg";
export { ForwardRef as ReactComponent };